// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, createProfileProfessional } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitCreateProfileApi = createAsyncThunk(
  "hitCreateProfileApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
      };
      const url = ApiBaseUrl + createProfileProfessional;
      const response = await axios.put(url, payload, config);
      return response.data;
    } catch (error) {
      showToast(error.response.data.message, "error");
      throw error.response.data;
    }
  }
);

const CreateProfileSlice = createSlice({
  name: "createProfileReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitCreateProfileData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitCreateProfileApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitCreateProfileApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        if (
          action.payload?.status == true &&
          action.payload?.data?.accessToken
        ) {
          localStorage.setItem(
            "professionalToken",
            action.payload.data.accessToken
          );
          localStorage.setItem("professionalId", action.payload.data._id);
          localStorage.setItem(
            "professionalData",
            JSON.stringify(action.payload.data)
          );
        }
      })
      .addCase(hitCreateProfileApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitCreateProfileData } = CreateProfileSlice.actions;
export default CreateProfileSlice.reducer;
